import { chunkArray } from './';
export const batchCopyService = async (filesGrouped, cb, size = 100, logger) => {
    const input = filesGrouped.files;
    const cbPromises = [];
    if (size <= 0) {
        logger.error("Invalid length ");
        throw Error('Invalid length');
    }
    chunkArray(input, size).forEach((chunk) => {
        const sources = [];
        chunk.forEach((path) => {
            sources.push(`${filesGrouped.repository}:${path.toString()}`);
        });
        cbPromises.push(cb(sources));
    });
    return await Promise.all(cbPromises);
};
